import * as request from '../../request'
import * as serializers from './serializers'

export const preLogin = async (data) => {
  try {
    const res = await request.post('v1/pre-auth', data)

    return serializers.preLogin(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const login = async (data, slt) => {
  try {
    const res = await request.post('v1/auth', data, {
      headers: { 'x-slt': slt }
    })

    return serializers.login(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const logout = async () => {
  try {
    const res = await request.del('v1/auth')

    return serializers.logout(res)
  } catch (err) {
    return Promise.reject(err)
  }
}
